export interface BrandDef {
  id: string
  name: string
  icon: string
  description: string
  category: 'text' | 'image' | 'video' | 'audio' | 'mixed'
}

const BRANDS: Record<string, BrandDef> = {
  chatgpt: { id: 'chatgpt', name: 'ChatGPT', icon: '/icons/gpt.svg', description: 'Текстовые модели от OpenAI', category: 'text' },
  claude: { id: 'claude', name: 'Claude', icon: '/icons/claude.svg', description: 'Текстовые модели от Anthropic', category: 'text' },
  gemini: { id: 'gemini', name: 'Gemini', icon: '/icons/gemini.svg', description: 'Мультимодальные модели от Google', category: 'text' },
  deepseek: { id: 'deepseek', name: 'DeepSeek', icon: '/icons/deepsek.svg', description: 'Текстовые модели DeepSeek', category: 'text' },
  grok: { id: 'grok', name: 'Grok', icon: '/icons/grok.svg', description: 'Текстовые модели от xAI', category: 'text' },
  'nano-banana': { id: 'nano-banana', name: 'Nano Banana', icon: '/icons/nanobanano.svg', description: 'Генерация изображений', category: 'image' },
  midjourney: { id: 'midjourney', name: 'Midjourney', icon: '/icons/midjournet.svg', description: 'Генерация изображений', category: 'image' },
  flux: { id: 'flux', name: 'Flux', icon: '/icons/flux.svg', description: 'Генерация изображений', category: 'image' },
  'stable-diffusion': { id: 'stable-diffusion', name: 'Stable Diffusion', icon: '/icons/stable.svg', description: 'Генерация изображений', category: 'image' },
  imagen: { id: 'imagen', name: 'Imagen', icon: '/icons/imagen.svg', description: 'Генерация изображений от Google', category: 'image' },
  'face-swap': { id: 'face-swap', name: 'Face Swap', icon: '/icons/faceswap.svg', description: 'Замена лиц на изображениях', category: 'image' },
  kling: { id: 'kling', name: 'Kling', icon: '/icons/kling.svg', description: 'Генерация видео', category: 'video' },
  sora: { id: 'sora', name: 'Sora', icon: '/icons/sora.svg', description: 'Генерация видео от OpenAI', category: 'video' },
  hailuo: { id: 'hailuo', name: 'Hailuo', icon: '/icons/hailuo.svg', description: 'Генерация видео от MiniMax', category: 'video' },
  veo: { id: 'veo', name: 'Veo', icon: '/icons/veo.svg', description: 'Генерация видео от Google', category: 'video' },
  seedance: { id: 'seedance', name: 'Seedance', icon: '/icons/seedance.svg', description: 'Генерация видео', category: 'video' },
  runway: { id: 'runway', name: 'Runway', icon: '/icons/runway.svg', description: 'Генерация видео и изображений', category: 'mixed' },
  luma: { id: 'luma', name: 'Luma', icon: '/icons/luma.svg', description: 'Генерация видео и изображений', category: 'mixed' },
  umnik: { id: 'umnik', name: 'Umnik AI', icon: '/icons/umnik-slides.svg', description: 'AI-инструменты для презентаций', category: 'mixed' },
  suno: { id: 'suno', name: 'Suno', icon: '/icons/suno.svg', description: 'Генерация музыки', category: 'audio' },
  mureka: { id: 'mureka', name: 'Mureka', icon: '/icons/mureka.svg', description: 'Генерация музыки', category: 'audio' },
  elevenlabs: { id: 'elevenlabs', name: 'ElevenLabs', icon: '/icons/elevenlabs.svg', description: 'Озвучка текста', category: 'audio' },
  'z-image': { id: 'z-image', name: 'Z-Image', icon: '/icons/z-image.svg', description: 'Сверхбыстрая генерация изображений', category: 'image' },
  seedream: { id: 'seedream', name: 'Seedream', icon: '/icons/seedream.svg', description: 'Генерация изображений от ByteDance', category: 'image' },
  animagine: { id: 'animagine', name: 'Animagine', icon: '/icons/animagine.svg', description: 'Генерация аниме-арта', category: 'image' },
  heygen: { id: 'heygen', name: 'HeyGen', icon: '/icons/heygen.svg', description: 'AI-аватары и перевод видео', category: 'video' },
  // Wan (Tongyi Lab, Alibaba): Wan 2.2 Animate Replace — замена человека в ролике аватаром (10.10), Wan 3.0 и 3.0 Prime —
  // генерация видео через KIE (19.10). Значок — официальный знак Wan (19.10): вектора у Wan нет, знак вырезан из logo.png
  // репозиториев Wan2.1/Wan2.2 и упакован в SVG, как heygen.svg.
  // ?v=2 (23.10): сервер отдаёт /icons/* с кэшем на 30 дней без перепроверки, а с 10 по 19.10 под этим же адресом лежал
  // временный значок — браузеры, заходившие раньше, держали его. Новый адрес заставляет взять официальный знак.
  wan: { id: 'wan', name: 'Wan', icon: '/icons/wan.svg?v=2', description: 'Видео от Alibaba: генерация и замена человека в ролике', category: 'video' },
  // P-Video (Pruna AI): P-Video-Replace — замена человека в ролике аватаром (10.10). Своего логотипа у P-Video нет, значок —
  // знак Pruna (19.10): вектор из шапки pruna.ai без надписи «Pruna AI». Владелец prunaai в OWNER_TO_BRAND — Z-Image,
  // поэтому P-Video ловит NAME_PATTERNS (они приоритетнее владельца).
  'p-video': { id: 'p-video', name: 'P-Video', icon: '/icons/p-video.svg?v=2', description: 'Видео от Pruna: замена человека в ролике', category: 'video' },
  gamma: { id: 'gamma', name: 'Gamma', icon: '/icons/gamma.svg', description: 'Создание презентаций с профессиональным дизайном', category: 'mixed' },
}

const ADAPTER_TO_BRAND: Record<string, string> = {
  openai: 'chatgpt',
  anthropic: 'claude',
  gemini: 'gemini',
  gemini_omni: 'gemini',
  // Прямая версия Omni: адаптер зарегистрирован под именем провайдера
  // ('google'), а не под именем модели. Без этой строки detectBrand()
  // вернёт null, и groupByBrand() молча выбросит карточку — модель
  // исчезнет из витрины и виджета, хотя /providers её отдаёт.
  google: 'gemini',
  deepseek: 'deepseek',
  xai: 'grok',
  nano_banana: 'nano-banana',
  kling: 'kling',
  // Прямой Kling (официальный API Kuaishou): адаптер зарегистрирован под
  // именем провайдера ('kling_direct'). Без этой строки detectBrand() вернёт
  // null, groupByBrand() молча выбросит карточку — модели не будет ни в
  // витрине, ни в виджете, хотя /providers её отдаёт.
  kling_direct: 'kling',
  // Kling 4.0 через KIE (adapters/kling4, 26.10).
  kling4: 'kling',
  midjourney: 'midjourney',
  veo: 'veo',
  sora: 'sora',
  hailuo: 'hailuo',
  runway: 'runway',
  seedance: 'seedance',
  flux: 'flux',
  suno: 'suno',
  mureka: 'mureka',
  elevenlabs: 'elevenlabs',
  gpt_image: 'chatgpt',
  gamma: 'gamma',
}

const OWNER_TO_BRAND: Record<string, string> = {
  'runwayml': 'runway',
  'luma': 'luma',
  'black-forest-labs': 'flux',
  'stability-ai': 'stable-diffusion',
  'kwaivgi': 'kling',
  'cdingram': 'face-swap',
  'bytedance': 'seedance',
  'openai': 'sora',
  'prunaai': 'z-image',
  'aisha-ai-official': 'animagine',
  'heygen': 'heygen',
  'google': 'imagen',
  'wan-video': 'wan',
  // Wan 3.0 — адаптер KIE wan (adapters/wan), id моделей wan/3-0-video[-prime].
  wan: 'wan',
}

const NAME_PATTERNS: [string, string][] = [
  ['nano-banana', 'nano-banana'],
  ['hailuo', 'hailuo'],
  ['veo', 'veo'],
  ['imagen', 'imagen'],
  ['sora', 'sora'],
  ['flux', 'flux'],
  ['seedance', 'seedance'],
  ['kling', 'kling'],
  ['midjourney', 'midjourney'],
  ['mj_', 'midjourney'],
  ['mj-', 'midjourney'],
  ['stable-diffusion', 'stable-diffusion'],
  ['face-swap', 'face-swap'],
  ['z-image', 'z-image'],
  ['seedream', 'seedream'],
  ['animagine', 'animagine'],
  ['heygen', 'heygen'],
  ['wan-', 'wan'],
  ['p-video', 'p-video'],
  ['gen4', 'runway'],
  ['gen-4', 'runway'],
  ['ray', 'luma'],
  ['photon', 'luma'],
  ['umnik', 'umnik'],
  ['gamma', 'gamma'],
]

// Модели, чей бренд НЕ определяется адаптером — умный-презентации 'umnik-slides'
// живёт под adapter='anthropic' (тот же провайдер, что и настоящий Claude), но
// на витрине это отдельная карточка «Umnik AI», а не модель Claude. Без этой
// проверки перед ADAPTER_TO_BRAND её бы молча слило в бренд 'claude'.
const MODEL_ID_TO_BRAND: Record<string, string> = {
  'umnik-slides': 'umnik',
}

export function detectBrand(adapterName: string, modelId: string): BrandDef | null {
  const override = MODEL_ID_TO_BRAND[modelId]
  if (override) return BRANDS[override] || null

  const direct = ADAPTER_TO_BRAND[adapterName]
  if (direct) return BRANDS[direct] || null

  const slashIdx = modelId.indexOf('/')
  if (slashIdx > 0) {
    const owner = modelId.substring(0, slashIdx)
    const name = modelId.substring(slashIdx + 1)

    // NAME_PATTERNS — приоритетнее OWNER_TO_BRAND: для 'google/nano-banana-2'
    // мы хотим вернуть бренд 'nano-banana', а не 'imagen' (owner=google).
    // Аналогично 'google/veo-3.1' → 'veo', а не 'imagen'.
    for (const [pattern, brandId] of NAME_PATTERNS) {
      if (name.startsWith(pattern)) return BRANDS[brandId] || null
    }

    const ownerBrand = OWNER_TO_BRAND[owner]
    if (ownerBrand) return BRANDS[ownerBrand] || null
  }

  for (const [pattern, brandId] of NAME_PATTERNS) {
    if (modelId.startsWith(pattern)) return BRANDS[brandId] || null
  }

  return null
}

export function isVariant(modelId: string): boolean {
  return modelId.includes(':')
}

// ─────────────────────────────────────────────────────────────────────
// MODEL_ID_ALIASES — синхронно с backend `MODEL_SETTINGS_ALIASES`
// (см. backend/app/api/v1/providers.py:85).
//
// Зачем: бэкенд регистрирует replicate-модели под «вендорской» длинной
// формой (`aisha-ai-official/animagine-xl-v4-opt`,
// `kwaivgi/kling-v3-motion-control`), а админ сохраняет их в
// `model_settings`/welcome-config в канонической короткой форме
// (`animagine-xl-v4`, `kling-v3-motion`). Фронт читает welcome-config
// и пытается найти модель в allModels — попадает в дыру и плитка не
// рендерится.
//
// Резолюция через `resolveModelIdAliases` сглаживает разрыв: для
// одного «канонического» id отдаём все известные алиасы, чтобы
// findModelById мог совпасть по любой форме.
//
// При добавлении нового алиаса в backend — продублировать сюда.
// ─────────────────────────────────────────────────────────────────────
const MODEL_ID_ALIASES: Record<string, string[]> = {
  // canonical short form → vendor long form(s)
  'animagine-xl-v4':       ['aisha-ai-official/animagine-xl-v4-opt'],
  'kling-v3-motion':       ['kwaivgi/kling-v3-motion-control'],
  'kling-v3-video':        ['kwaivgi/kling-v3-video'],
  'kling-v3-omni':         ['kwaivgi/kling-v3-omni-video'],
  'sd-3.5-large':          ['stability-ai/stable-diffusion-3.5-large'],
  'sd-3.5-large-turbo':    ['stability-ai/stable-diffusion-3.5-large-turbo'],
  'sd-3.5-medium':         ['stability-ai/stable-diffusion-3.5-medium'],
  'z-image-turbo':         ['prunaai/z-image-turbo'],
  'seedance-2.0':          ['bytedance/seedance-2.0'],
  'seedance-2.0-fast':     ['bytedance/seedance-2.0-fast'],
  'seedream-4.5':          ['bytedance/seedream-4.5'],
  'seedream-5-lite':       ['bytedance/seedream-5-lite'],
  'flux-3-klein':          ['flux-3/klein-text-to-image'],
  'flux-3-image':          ['black-forest-labs/flux-3-image'],
  'seedance-pro':          ['bytedance/seedance-1-pro'],
  'seedance-pro-fast':     ['bytedance/seedance-1-pro-fast'],
  'seedance-lite':         ['bytedance/seedance-1-lite'],
  'heygen-video-agent':    ['heygen/video-agent'],
  'heygen-avatar-iv':      ['heygen/avatar-iv'],
  'heygen-video-translate':['heygen/video-translate'],
  'minimax-image':         ['minimax/image-01'],
  'minimax-video':         ['minimax/video-01'],
  'minimax-speech-turbo':  ['minimax/speech-02-turbo'],
  'minimax-speech-hd':     ['minimax/speech-02-hd'],
  'veo-3.1-fast':          ['google/veo-3.1-fast'],
  'veo-3.1-lite':          ['google/veo-3.1-lite'],
  'veo-3.1':               ['google/veo-3.1'],
  'nano-banana-2':         ['google/nano-banana-2'],
  'nano-banana-2-1':       ['google/nano-banana-2.1'],
  'nano-banana-pro':       ['google/nano-banana-pro'],
  'luma-photon-flash':     ['luma/photon-flash'],
  'luma-ray':              ['luma/ray'],
  'luma-ray-flash-2-540p': ['luma/ray-flash-2-540p'],
  'runway-gen4-image':     ['runwayml/gen4-image'],
  'runway-gen4-image-turbo': ['runwayml/gen4-image-turbo'],
  'runway-gen4-turbo':     ['runwayml/gen4-turbo'],
  'wan-2.2-animate-replace': ['wan-video/wan-2.2-animate-replace'],
  'p-video-replace': ['prunaai/p-video-replace'],
}

// Реверс-индекс: длинная вендорская форма → канонический short id.
// Используется в `resolveModelIdAliases` для two-way резолюции:
// если ищем по длинной форме, отдаём также короткую.
const REVERSE_MODEL_ID_ALIASES: Record<string, string> = (() => {
  const m: Record<string, string> = {}
  for (const [canonical, longs] of Object.entries(MODEL_ID_ALIASES)) {
    for (const long of longs) m[long] = canonical
  }
  return m
})()

/**
 * Возвращает все известные формы id для данной модели (включая саму).
 * Если modelId — канонический short form, добавляются все его длинные
 * vendor-формы. Если modelId — vendor-форма, добавляется canonical
 * short form и его остальные vendor-формы.
 *
 * Использовать в findModelById/resolveModel где id может прийти в любой
 * из форм (welcome-config даёт short, /providers — long).
 */
export function resolveModelIdAliases(modelId: string): string[] {
  if (!modelId) return []
  const aliases = new Set<string>([modelId])
  if (MODEL_ID_ALIASES[modelId]) {
    for (const long of MODEL_ID_ALIASES[modelId]) aliases.add(long)
  }
  const canonical = REVERSE_MODEL_ID_ALIASES[modelId]
  if (canonical) {
    aliases.add(canonical)
    for (const long of MODEL_ID_ALIASES[canonical] || []) aliases.add(long)
  }
  return Array.from(aliases)
}

// Реверс-маппинг icon-url → brandId. Используется в чате для применения
// brand-specific анимаций к иконке модели рядом с сообщением (на ассистент-
// сообщениях через data-brand="...").
// Собирается один раз при импорте модуля — BRANDS неизменен в рантайме.
// Адрес без «?…»: версия в адресе значка (?v=2 против кэша браузера) не должна ломать узнавание бренда — и у адресов
// из каталога админки, сохранённых до версии, и у новых.
const iconPath = (url: string) => url.split('?')[0]

const ICON_URL_TO_BRAND_ID: Record<string, string> = (() => {
  const m: Record<string, string> = {}
  for (const [id, brand] of Object.entries(BRANDS)) {
    m[iconPath(brand.icon)] = id
  }
  return m
})()

export function brandIdFromIcon(iconUrl: string | undefined | null): string | null {
  if (!iconUrl) return null
  return ICON_URL_TO_BRAND_ID[iconPath(iconUrl)] ?? null
}